import { defineStore } from 'pinia'
import { ApiError, request } from '../services/http'
export interface AuthUser {
  id: number
  name: string
  email: string
  role: 'admin' | 'employee'
  status: 'active' | 'inactive'
  permissions?: string[]
  permission_group?: string | null
  permission_group_id?: number | null
  effective_permissions?: string[]
}
export const useAuthStore = defineStore('auth', {
  state: () => ({ user: null as AuthUser | null, initialized: false }),
  actions: {
    async restore() {
      try {
        const result = await request<{ user: AuthUser; effective_permissions?: string[] }>('/api/auth/me')
        this.user = { ...result.user, effective_permissions: result.effective_permissions ?? [] }
        this.initialized = true
      } catch (error) {
        this.user = null
        if (!(error instanceof ApiError) || ![401, 403].includes(error.status)) throw error
        this.initialized = true
      }
    },
    async login(email: string, password: string) {
      await request('/sanctum/csrf-cookie')
      const result = await request<{ user: AuthUser; effective_permissions?: string[] }>('/api/auth/login', 'POST', { email, password })
      this.user = { ...result.user, effective_permissions: result.effective_permissions ?? [] }
      this.initialized = true
    },
    async logout() {
      try {
        await request('/sanctum/csrf-cookie')
        await request('/api/auth/logout', 'POST')
      } catch (error) {
        if (!(error instanceof ApiError) || error.status !== 401) throw error
      }
      this.user = null
      this.initialized = true
    },
  },
})
